import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import styled from 'styled-components'
import api from '../../api'
import FailureIcon from '../../assets/icons/JSX/FailureIcon'
import Colors from '../../assets/styles/Colors'
import Loader from '../../components/Loader'
import { RootState } from '../../store'
import { AuthState } from '../../store/authSlice'
//
//
type new_user = {
  email: string
  password: string
}
//
//
const PayFailureScreen = () => {
  //
  //
  // login mutation
  const [login, { isLoading }] = api.useLoginMutation()
  //
  const auth = useSelector<RootState, AuthState>((state) => state.auth)
  //
  const { t } = useTranslation()
  //
  const navigate = useNavigate()
  //
  const [new_user, setNew_user] = useState<new_user | null>(null)
  //
  //
  useEffect(() => {
    const newUserFromLocalStorage = localStorage.getItem('new_user')
    //
    const newUser = newUserFromLocalStorage && JSON.parse(newUserFromLocalStorage)
    //
    if (newUser) {
      setNew_user(newUser)
    }
    //
    return () => {}
  }, [new_user])
  //
  //
  const Login = async () => {
    if (new_user) {
      try {
        await login({ email: new_user.email, password: new_user.password }).unwrap()
        //
        localStorage.removeItem('new_user')
        navigate(`/my-policies`)
      } catch (error: any) {
        if (error?.data?.errors?.constructor === Array) {
          const firstError = error.data.errors[0]
          const errorMessage = firstError.message
          toast.error(errorMessage)
          localStorage.removeItem('new_user')
        } else {
          toast.error('Მოხდა შეცდომა. Გთხოვთ სცადოთ მოგვიანებით... (Login) (PayFailureScreen)')
          localStorage.removeItem('new_user')
        }
      }
    }
  }
  //
  //
  return isLoading ? (
    <Loader />
  ) : (
    <Wrapper>
      <Icon />
      <Title>{t('paymentFailded')}</Title>
      <Text>{t('paymentFailedText')}</Text>
      {auth.user && auth.user.userType === 'User' ? (
        <LinkStyle to="/my-policies">{t('goToAccount')}</LinkStyle>
      ) : new_user ? (
        <NewUserDiv onClick={Login}>{t('goToAccount')}</NewUserDiv>
      ) : (
        <LinkStyle to="/">{t('goToLanding')}</LinkStyle>
      )}
    </Wrapper>
  )
}
//
// styles
const NewUserDiv = styled.div`
  font-size: 14px;
  color: ${Colors.primaryBlack};
  margin-top: 15px;
  cursor: pointer;
  text-decoration: underline;
  user-select: none;
  &:hover {
    color: ${Colors.primaryBlack};
    opacity: 0.9;
  }
`
const LinkStyle = styled(Link)`
  font-size: 14px;
  color: ${Colors.primaryBlack};
  margin-top: 15px;
  &:hover {
    color: ${Colors.primaryBlack};
    opacity: 0.9;
  }
`
const Text = styled.p`
  font-size: 14px;
  margin-top: 15px;
  text-align: center;
  max-width: 400px;
  width: 100%;
  padding-inline: 15px;
`

const Title = styled.div`
  font-size: 24px;
  color: ${Colors.primaryBlack};
  margin-top: 10px;
`
const Icon = styled(FailureIcon)`
  background-color: transparent;
  width: 200px;
  height: 180px;
`
const Wrapper = styled.div`
  height: 100vh;
  width: 100%;
  background-color: ${Colors.backgroundGrey};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`
export default PayFailureScreen
